export default __webpack_public_path__ + "static/media/rnr-sports-table-21.a637102a.webp";